import styled from '@emotion/styled'

import { mediaDown, mediaUp } from '@/styles/media'
import { H3, Text2 } from '@/styles/typography'
import { colors } from '@/styles/theme'

interface PriceWrapperProps {
  shouldHighlightPrice: boolean
}

export const TileContainer = styled.div`
  border-radius: 24px;
  box-shadow: 0px 4px 24px 0px rgba(9, 55, 105, 0.08);
  display: grid;
  background: #fff;
  position: relative;
  width: 320px;
  margin-bottom: 24px;
  cursor: pointer;
  ${mediaUp('md')} {
    display: flex;
    padding: 12px;
    margin: 8px;
    width: unset;
  }
`
export const TagsWrapper = styled.div`
  display: flex;
  margin-bottom: 12px;
  margin-right: 6px;
  ${mediaUp('md')} {
    margin-bottom: 6px;
    width: 110%;
    margin-right: 0px;
  }
  ${mediaUp('lg')} {
    margin-bottom: 24px;
    width: unset;
    margin-right: 6px;
  }
`

export const ImageContainer = styled.div``

export const InfoContainer = styled.div`
  flex: 2;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  width: 320px;
  ${mediaUp('md')} {
    width: 100px;
    padding: 0 0 0 20px;

    html[lang^='ar'] & {
      padding: 0 20px 0 0;
    }
  }
`

export const PriceAndButton = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  ${mediaUp('md')} {
    justify-content: flex-end;
  }
`

export const Price = styled.span`
  font-weight: bold;
  color: green;
`

export const AddressWrapper = styled.div`
  display: flex;
  gap: 8px;
`

export const PriceWrapper = styled.div<PriceWrapperProps>`
  border-radius: 17px;
  background: ${({ shouldHighlightPrice }) =>
    shouldHighlightPrice ? 'rgba(255, 0, 0, 0.12)' : colors.paleGrey};
  display: flex;
  height: 34px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  white-space: nowrap;
  ${mediaUp('md')} {
    margin-left: unset;
    min-width: 68px;
  }
`

export const LowestPriceWrapper = styled.div`
  text-align: right;
`

export const CrossedText2 = styled.p`
  ${Text2}
  font-size: 14px;
  font-weight: 800;
  text-decoration: line-through;
  color: ${colors.blueyGrey};
`

export const StyledImageWrapper = styled.div`
  width: 320px;
  height: 128px;
  overflow: hidden;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  ${mediaUp('md')} {
    width: 228px;
    height: 100%;
    border-radius: 8px;
    cursor: pointer;
  }
`

export const ParkingTitle = styled(H3)`
  font-size: 16px;
  margin: 16px 0 8px 0;
  ${mediaUp('md')} {
    font-size: 21px;
    margin-top: unset;
    width: 80%;
  }
`

export const DoubleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
export const DoubleColumnRow = styled.div`
  display: grid;
`

export const DistanceInfo = styled.div`
  color: #6c7075;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin: 8px 0;
  display: flex;
  align-items: center;
  gap: 4px;
  ${mediaUp('md')} {
    margin: 12px 0;
  }
`

export const ParkingMetaSection = styled.div`
  width: 100%;
  height: 26px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
`

export const ParkingRoutingSection = styled.div<{ multipleLines?: boolean }>`
  width: ${({ multipleLines }) => (multipleLines ? '90%' : '120%')};
  height: 26px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: ${({ multipleLines }) =>
    multipleLines ? '0 0 16px 0' : '16px 0 8px 0'};
  gap: 10px;
  display: ${({ multipleLines }) => (multipleLines ? 'block' : '')};
`

export const LastBookedContainer = styled.div`
  display: flex;
  height: 100%;
  background-color: ${colors.lightGreen};
  color: ${colors.green};
  font-weight: 750;
  font-size: 14px;
  border-radius: 12px;
  padding: 0 8px;
  align-items: center;
  gap: 4px;
  width: fit-content;

  ${mediaDown('md')} {
    font-size: 10px;
    height: 24px;
    margin-bottom: 10px;
  }
`

export const RatingContainer = styled.div`
  padding-right: 4px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
`

export const ReviewsText = styled.p`
  color: ${colors.darkSkyBlue};
  font-weight: 600;
  font-size: 14px;
`

export const RatingText = styled.p`
  color: ${colors.gold};
  font-weight: 900;
  font-size: 18px;
  display: flex;
  align-items: center;
  gap: 4px;
`

export const DistanceContainer = styled.div`
  width: fit-content;
  border-radius: 10px;
  border: 1.5px solid ${colors.cloudyBlue};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px 6px;
  gap: 8px;

  ${mediaDown('md')} {
    padding: 2px;
    font-size: 12px;
    border-radius: 6px;
  }
`
export const FacilityItem = styled.div<{ seperated: boolean }>`
  display: ${({ seperated }) => (seperated ? 'flex' : 'inline-flex')};
  align-items: center;
  color: ${colors.twilightBlue};
  font-weight: 600;
  font-size: 14px;
  padding: 0 10px 0 0;
  gap: 6px;
`

export const SegmentedInformationSection = styled.div`
  height: 128px;
`

export const ParkingFacilities = styled.div`
  width: 70%;
`

export const DiscountDescription = styled.div`
  width: 20%;
`

export const RoutingText = styled.div`
  font-weight: 700;
  font-size: 14px;
`

export const BoldRoutingText = styled.p`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 4px;
`

export const FacilityMobileWrapper = styled.div`
  margin-bottom: 10px;
`
